// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__Mu2-x","actionsCol":"EnrolledClinics_actionsCol__fX85V"};